import { useParams, Link } from "react-router-dom";
import { projects } from "../../data/projects";
import { useEffect } from "react";

import html from "../../img/tech/lg-html.svg";
import css from "../../img/tech/lg-css.svg";
import js from "../../img/tech/lg-js.svg";
import react from "../../img/tech/lg-react.svg";
import figma from "../../img/tech/lg-figma.svg";
import fluigImg from "../../img/tech/lg-fluig.png";
import php from "../../img/tech/lg-php.svg";
import laravel from "../../img/tech/lg-laravel.png";
import sass from "../../img/tech/lg-sass.png";
import jquery from "../../img/tech/lg-jquery.svg";
import sqlserver from "../../img/tech/lg-sql.png";
import twilio from "../../img/tech/lg-twilio.svg";
import node from "../../img/tech/lg-node.svg";
import rm from "../../img/tech/lg-rm.png";
import lightRight from "../../img/others/lightRight.svg";
import lightLeft from "../../img/others/lightLeft.svg";

const techIcons = {
  html: { img: html, label: "HTML" },
  css: { img: css, label: "CSS" },
  js: { img: js, label: "JavaScript" },
  react: { img: react, label: "React" },
  figma: { img: figma, label: "Figma" },
  fluig: { img: fluigImg, label: "Fluig" },
  php: { img: php, label: "PHP" },
  laravel: { img: laravel, label: "Laravel" },
  sass: { img: sass, label: "Sass" },
  jquery: { img: jquery, label: "jQuery" },
  sqlserver: { img: sqlserver, label: "Sql Server" },
  twilio: { img: twilio, label: "Twilio" },
  node: { img: node, label: "Node JS" },
  rm: { img: rm, label: "TOTVS RM" },
};

export default function ProjectDetail() {
  const { slug } = useParams();
  const project = projects.find((p) => p.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!project) {
    return (
      <div className="projectDetail-notFound">
        <h1>Projeto não encontrado</h1>
        <Link to="/" className="btn-blue-1">
          Voltar ao início
        </Link>
      </div>
    );
  }

  return (
    <div className="projectDetail-container">
      <img
        alt=""
        src={lightRight}
        className="lightRight projectDetail-lightRight"
      />
      <img
        alt=""
        src={lightLeft}
        className="lightLeft projectDetail-lightLeft"
      />

      <header className="projectDetail-header">
        <div className="projectDetail-headerTop">
          <h1 className="projectDetail-title">{project.nameProject}</h1>
        </div>
        <p className="projectDetail-subtitle paragraph">
          {project.description}
        </p>
      </header>

      <div
        className="projectDetail-image"
        style={{ backgroundImage: `url(${project.image})` }}
      />

      <main className="projectDetail-main">
        <section className="projectDetail-about">
          <h2 className="projectDetail-sectionTitle">Sobre o projeto</h2>
          <div className="projectDetail-paragraphs">
            {project.fullDescription.map((text, i) => (
              <p key={i} className="paragraph projectDetail-text">
                {text}
              </p>
            ))}
          </div>
        </section>

        <aside className="projectDetail-aside">
          <div className="projectDetail-highlights">
            <h2 className="projectDetail-sectionTitle">Destaques</h2>
            <ul className="projectDetail-highlightList">
              {project.highlights.map((item, i) => (
                <li key={i} className="projectDetail-highlightItem">
                  <span className="material-symbols-outlined projectDetail-checkIcon">
                    check_circle
                  </span>
                  <span className="paragraph">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="projectDetail-stack">
            <h2 className="projectDetail-sectionTitle">Stack</h2>
            <ul className="projectDetail-stackList">
              {project.technologies.map((tech) => {
                const data = techIcons[tech.toLowerCase()];
                return data ? (
                  <li key={tech} className="projectDetail-stackItem">
                    <img
                      className="projectDetail-stackImg"
                      src={data.img}
                      alt={data.label}
                    />
                    <span className="paragraph">{data.label}</span>
                  </li>
                ) : null;
              })}
            </ul>
          </div>

          <div className="projectDetail-links">
            {project.link ? (
              <a
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-blue-1"
              >
                Ver demo
                <span className="material-symbols-outlined">arrow_outward</span>
              </a>
            ) : (
              <span className="projectDetail-btnDisabled">
                Demo indisponível
                <span className="material-symbols-outlined">lock</span>
              </span>
            )}

            {project.githubLink ? (
              <a
                href={project.githubLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-white-1"
              >
                Repositório
                <span className="material-symbols-outlined">arrow_outward</span>
              </a>
            ) : (
              <span className="projectDetail-btnDisabled">
                Repositório privado
                <span className="material-symbols-outlined">lock</span>
              </span>
            )}
          </div>
        </aside>
      </main>
    </div>
  );
}
